import { WebSocketLink } from '@apollo/client/link/ws'

export const websocketLink = new WebSocketLink({
  uri: `${location.protocol.replace('http', 'ws')}//${
    /localhost/.test(location.hostname) ? 'localhost:4000' : location.hostname
  }/ws`,
  options: {
    reconnect: true,
    lazy: true,
    reconnectionAttempts: 3,
  },
  webSocketImpl: WebSocket,
})
